import { render, staticRenderFns } from "./createAccount.vue?vue&type=template&id=a3c0bf48"
import script from "./createAccount.vue?vue&type=script&lang=js"
export * from "./createAccount.vue?vue&type=script&lang=js"
import style0 from "./createAccount.vue?vue&type=style&index=0&id=a3c0bf48&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3c0bf48')) {
      api.createRecord('a3c0bf48', component.options)
    } else {
      api.reload('a3c0bf48', component.options)
    }
    module.hot.accept("./createAccount.vue?vue&type=template&id=a3c0bf48", function () {
      api.rerender('a3c0bf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/setup/components/createAccount/createAccount.vue"
export default component.exports